import {Injectable} from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AgentStateService {
  private stateSource = new BehaviorSubject<string | null>(this.loadStateFromStorage());
  currentState$ = this.stateSource.asObservable();

  private lastUpdateSource = new BehaviorSubject<Date | null>(this.getLastUpdate());
  currentLastUpdate$ = this.lastUpdateSource.asObservable();


  readonly LS_ALL_STATES: string = 'all_status_agent';
  readonly LS_STATUS_AGENT: string = 'status_agent';
  readonly LS_LAST_UPDATE: string = 'last_update';

  constructor(

  ) { }

  private loadStateFromStorage(): string | null {
    const userData = localStorage.getItem(this.LS_LAST_UPDATE);
    return userData ? JSON.parse(userData) : null;
  }

  setAgentState(state: string): void {
    localStorage.setItem(this.LS_STATUS_AGENT, JSON.stringify(state));
    this.stateSource.next(state);
  }

  getAgentState(): string | null {
    return this.loadStateFromStorage();
  }

  // get StateUpdate(): Observable<string | null> {
  //   return this.stateSource.asObservable();
  // }

  setLastUpdate(date: Date): void {
    localStorage.setItem(this.LS_LAST_UPDATE, date.toISOString());
    this.lastUpdateSource.next(date);
  }

  getLastUpdate(): Date | null {
    const lastUpdate = localStorage.getItem(this.LS_LAST_UPDATE);
    return lastUpdate ? new Date(lastUpdate) : null;
  }

  clearState(): void {
    localStorage.removeItem(this.LS_STATUS_AGENT);
    this.stateSource.next(null);
  }

}
